import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { getCountries } from 'actions/countries';
import Button from 'components/Button';
import TextField from 'components/TextField';
import Select from 'components/Select';
import {
  Container,
  Information,
} from 'styles/pages/orders/basicOrderShippingInformationForm';

const ShippingInformation = ({ save }) => {
  const dispatch = useDispatch();
  const countries = useSelector((state) => state?.countries?.data);
  const [statesList, setStateList] = useState([]);

  const [state, setState] = useState({
    BuyerName: '',
    AddressLineOne: '',
    AddressLineTwo: '',
    City: '',
    StateProvince: '',
    CountryString: '',
    ZipPostal: '',
    PrintProvider: '',
    Sample: false,
    ReOrderState: 0,
  });

  const disabled = !(
    state.BuyerName.length &&
    state.AddressLineOne.length &&
    state.City.length &&
    state.StateProvince.length &&
    state.CountryString.length &&
    state.ZipPostal.length &&
    state.PrintProvider.length
  );

  useEffect(() => {
    const loadCountries = async () => {
      if (!countries?.length) {
        dispatch(getCountries());
      }
    };
    loadCountries();
  }, [dispatch, countries]);

  return (
    <Container>
      <h2>Create a Basic Order </h2>
      <Information>
        <TextField
          fullWidth
          size="small"
          label="Full Name"
          onChange={(BuyerName) => setState({ ...state, BuyerName })}
        />
        <TextField
          fullWidth
          size="small"
          label="Address Line 1"
          onChange={(AddressLineOne) => setState({ ...state, AddressLineOne })}
        />
        <TextField
          fullWidth
          size="small"
          label="Address Line 2"
          onChange={(AddressLineTwo) => setState({ ...state, AddressLineTwo })}
        />
        <Select
          label="Country"
          options={countries}
          labelKey="name"
          valueKey="code2"
          value={{ code2: state.CountryString }}
          onChange={(CountryString) => {
            const states = _.find(
              countries,
              (o) => o.code2 === CountryString
            )?.states;
            setStateList(states);
            setState({
              ...state,
              CountryString,
              StateProvince: '',
            });
          }}
        />
        <Select
          label="State/Province"
          labelKey="name"
          valueKey="code"
          options={statesList}
          value={{ code: state.StateProvince }}
          onChange={(StateProvince) =>
            setState({
              ...state,
              StateProvince,
            })
          }
        />
        <TextField
          fullWidth
          size="small"
          label="City"
          onChange={(City) => setState({ ...state, City })}
        />
        <TextField
          fullWidth
          size="small"
          label="Zip/Postal"
          onChange={(ZipPostal) => setState({ ...state, ZipPostal })}
        />

        <Select
          label="Fulfillment Plant"
          labelKey="name"
          valueKey="value"
          options={[
            { value: 'CA', name: 'Canadian Fulfillment Plant' },
            { value: 'US', name: 'USA Fulfillment Plant' },
            { value: 'AU', name: 'Australia Fulfillment Plant' },
            { value: 'EU', name: 'Europe Fulfillment Plant' },
          ]}
          value={{ value: state.PrintProvider }}
          onChange={(PrintProvider) =>
            setState({
              ...state,
              PrintProvider,
            })
          }
        />
      </Information>
      {state?.PrintProvider?.length > 0 && (
        <h5>
          Only selected fulfillment plant products will be visible while placing
          the order
        </h5>
      )}
      <Button
        title="Continue"
        onClick={() => _.isFunction(save) && save(state)}
        disabled={disabled}
      />
    </Container>
  );
};

export default ShippingInformation;
